import { NgModule } from '@angular/core';

import { SharedModule } from '../../../shared';

import { NaturezaVendaSituacaoBadgeComponent } from './badge';
import { NaturezaVendaSituacaoPipe, NaturezaVendaSituacaoFilterPipe } from './pipes';

@NgModule({
    imports: [
        SharedModule
    ],
    declarations: [
        NaturezaVendaSituacaoBadgeComponent,
        // Pipes
        NaturezaVendaSituacaoPipe,
        NaturezaVendaSituacaoFilterPipe
    ],
    exports: [
        NaturezaVendaSituacaoBadgeComponent,
        // Pipes
        NaturezaVendaSituacaoPipe,
        NaturezaVendaSituacaoFilterPipe
    ],
    providers: [
        // Pipes
        NaturezaVendaSituacaoPipe,
        NaturezaVendaSituacaoFilterPipe
    ]
})
export class NaturezaVendaSituacaoModule { }
